import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import type { SubscriberFilters } from '../models/subscriber'
import { GetSubscriberFiltersQuery } from '../../data/queries/get-subscriber-filters.query'
import type { SubscriberFiltersEntity } from '../../data/entities/subscriber.entity'

export interface GetSubscriberFiltersParams {
  organization: string
}

export class GetSubscriberFiltersInteractor {
  constructor(private readonly repository: GetInteractor<SubscriberFiltersEntity>) {}

  public async execute(params: GetSubscriberFiltersParams): Promise<SubscriberFilters> {
    return await this.repository.execute(new GetSubscriberFiltersQuery(params.organization))
  }
}
